import { string } from 'prop-types'

import { formatPathWithLanguage } from 'shared/utils/url'
import IconArrowLeft from 'views/components/atoms/Icon/IconArrowLeft'
import LinkWithIcon from 'views/components/molecules/LinkWithIcon'
import { navItemType } from 'views/utils/propTypes'
import { usePublicConfig } from 'views/utils/shopAndRuntimeConfigUtils'

const BackToIndexLink = ({ navItem, className }) => {
  const config = usePublicConfig()
  const { language, tenant } = config
  const formatPath = formatPathWithLanguage(tenant)(language)

  if (!navItem) {
    return null
  }

  return (
    <LinkWithIcon
      className={className}
      href={formatPath(navItem.path)}
      icon={<IconArrowLeft size="small" />}
    >
      {navItem.caption}
    </LinkWithIcon>
  )
}

BackToIndexLink.propTypes = {
  navItem: navItemType,
  className: string,
}

BackToIndexLink.defaultProps = {
  navItem: null,
  className: null,
}

export default BackToIndexLink
